
import React from 'react';
import PropTypes from 'prop-types';

import { StyledOptionField, StyledOptionStack, StyledSpacedOptionFields } from '../../../components/common/AnnotationOptions/AnnotationOptions.styled';
import restrictNumber from '../../../utils/restrictNumber';
import Slider from '../../../components/common/Slider';

const MIN_VALUE = 0;
const MAX_VALUE = 150;
const POPUP_SLIDER_WIDTH = '100%';

const RectCornerField = ({
  annotation: rect,
  updateAnnotation: updateRect,
  t,
}) => {
  const { cornerRadius } = rect;

  const updateCornerRadius = (newCornerRadius) => {
    updateRect({
      cornerRadius: restrictNumber(newCornerRadius, MIN_VALUE, MAX_VALUE),
    });
  };

  return (
    <StyledSpacedOptionFields className="respark_annotation-option-panel">
      <StyledOptionStack>
        <StyledOptionField>
          <Slider
            width={POPUP_SLIDER_WIDTH}
            annotation="px"
            onChange={updateCornerRadius}
            value={cornerRadius}
            min={MIN_VALUE}
            max={MAX_VALUE}
          />
        </StyledOptionField>
      </StyledOptionStack>
    </StyledSpacedOptionFields>
  );
};

RectCornerField.propTypes = {
  annotation: PropTypes.instanceOf(Object).isRequired,
  updateAnnotation: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

export default RectCornerField;
